export default __webpack_public_path__ + "static/media/how_to_play_icon_3.346928c7.png";